import AxiosManager from "./axiosManager";
import apiManager from "./apiManager";

var apiUrl=process.env.VUE_APP_apiUrl ;
// var apiUrl="/";
//var apiPathBase="api/test/";
// var apiUrl="http://192.168.0.156:8080/";
var apiPathBase="CouponApiByT/";
// var apiPathBase="api/admin/";
const subID_Field="C";
import util from "@/js/util";

export default {
    //---------------axios------------------------
    getAxiosManager(){
        return new AxiosManager("sessionkey" + "tokenkey")
    },
    //---------------------------------------

    //---------------------------------------
    getApiManager() {
        let apiUrlReal="";

        if (apiUrl){
            apiUrlReal=apiUrl +"/";
        }else{
            apiUrlReal=window.location.protocol + "//"+ window.location.host + "/";
        }

        return new apiManager(apiUrlReal,apiPathBase,"",this.getAxiosManager(),null)
    },

    api_testPost (postValue)
    {
        let data={
            data:postValue,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("testPost",data)
    },

    api_testGet (passValue)
    {
        let data={
            data:passValue
        }

        return this.getApiManager().api_CallMethod_Get("testGet",data)
    },

    //---------------------------------------
    api_getCouponList(subID,couponTag)
    {
        let data={
            [subID_Field]:subID,
            couponTag:couponTag
        }

        return this.getApiManager().api_CallMethod_Get("getCouponList",data)
    },
    api_getMyCoupons(subID,isUsed) //isUsed:Y/N
    {
        let data={
            [subID_Field]:subID,
            isUsed:isUsed
        }

        return this.getApiManager().api_CallMethod_Get("getMyCoupons",data)
    },
    api_getCouponDetail(subID,userCouponSID,couponSID,received)
    {
        let data={
            [subID_Field]:subID,
            userCouponSID:userCouponSID,
            couponSID:couponSID,
            received:received
        }

        return this.getApiManager().api_CallMethod_Get("getCouponDetail",data)
    },
    api_getCouponDetail2(subID,couponSID)
    {
        let data={
            [subID_Field]:subID,
            couponSID:couponSID,
        }

        return this.getApiManager().api_CallMethod_Get("getCouponDetail2",data)
    },
    api_getCoupon(subID,couponSID)
    {
        let data={
            [subID_Field]:subID,
            couponSID:couponSID
        }

        return this.getApiManager().api_CallMethod_Get("getCoupon",data)
    },
    api_useCoupon(subID,couponSID,userCouponSID)
    {
        let data={
            [subID_Field]:subID,
            couponSID:couponSID,
            userCouponSID:userCouponSID
        }

        return this.getApiManager().api_CallMethod_Get("useCoupon",data)
    },
    api_useCoupon2(subID,couponSID)
    {
        let data={
            [subID_Field]:subID,
            couponSID:couponSID,
        }

        return this.getApiManager().api_CallMethod_Get("useCoupon2",data)
    },
    api_getMaintainModeMessage()
    {
        let data={
        }

        return this.getApiManager().api_CallMethod_Get("getMaintainModeMessage",data)
    },
    //---------------------------------------
    handleStatus(data){
        let apiData=data.data;
        if (apiData.status && apiData.status==="ok"){
            return data;
        }else{
            if (apiData.message){
                util.ShowMessage(apiData.message);
            }
            return data;
        }
    },
    //---------------------------------------
    api_test(passValue)
    {
        let data={
            data:passValue
        }

        return this.getApiManager().api_CallMethod_Get("test",data)
    },
}
